import AudiencePage from "@/components/AudiencePage";

const INCLUDED = [
  ["Regular, on-time stocking", "We restock on a dependable schedule shaped by what your residents actually buy — drinks, snacks, chips, candy, and healthier options."],
  ["Cleaning on every visit", "Every service visit includes a full machine wipe-down and a freshness check of everything on the shelves — important in shared resident spaces."],
  ["Maintenance handled by us", "Cooler, screen, or card reader trouble is our job, not your maintenance team's. We service the equipment end to end."],
  ["Custom product selection", "The mix is tailored to your building's residents. They can request items anytime by scanning the QR code on the machine."],
  ["Prompt response to issues", "Call, email, or scan the QR code on the machine. A real person follows up fast, Monday–Friday, 8 AM – 8 PM."],
];

const FAQS = [
  {
    q: "What does it cost the property?",
    a: "Nothing. There is no cost to the property or management company: we provide the smart cooler, install it, and handle all stocking, cleaning, and maintenance. Residents pay only for the items they buy.",
  },
  {
    q: "Where in the building does the cooler go?",
    a: "The most common spots are lobbies, fitness rooms, and mailrooms — anywhere residents already pass through. The cooler needs about the footprint of a standard refrigerator and a wall outlet. We help you pick the placement during a walkthrough.",
  },
  {
    q: "What does our property staff have to do?",
    a: "Nothing, day to day. Stocking, cleaning, maintenance, and repairs are all handled by Vortex Vending Services. There is no staffing burden on management — the machine runs itself and we keep it that way.",
  },
  {
    q: "Can residents request specific products?",
    a: "Yes. Every machine carries a QR code residents can scan to send suggestions and requests directly to us — favorite drinks, snack requests, or a heads-up about an issue. We read every message and adjust the building's mix accordingly.",
  },
  {
    q: "When can residents use it?",
    a: "Whenever the room it lives in is open. In buildings with 24/7 lobbies, fitness rooms, or mailrooms, that means residents can grab a drink or snack at any hour — no store run needed.",
  },
  {
    q: "How do residents pay?",
    a: "Fully cashless. The reader on the door accepts credit and debit cards plus mobile wallets, and residents can see everything through the glass before they buy.",
  },
];

const ApartmentVending = () => (
  <AudiencePage
    testId="apartment-vending-page"
    overline="For Apartment Buildings & Property Managers"
    h1Lines={["SMART COOLER VENDING FOR", "APARTMENT BUILDINGS IN", "WEST CHESTER, PA."]}
    accentIndex={2}
    intro="Give residents a genuinely useful amenity: a stocked smart cooler in the lobby, fitness room, or mailroom with 24/7 access in the spaces that never close — without adding a single task to your team's list."
    howTitle="An amenity that runs itself."
    howText="We place the cooler in a shared space your residents already use. They browse through the glass, tap a card or phone on the reader, and the door unlocks — grab and go, any hour the room is open. Meanwhile the machine reports its inventory to us, so restocking, cleaning, and upkeep happen on our schedule, not yours. Property managers get the amenity credit without the operational work."
    included={INCLUDED}
    faqs={FAQS}
    imageKey="lounge"
    imageAlt="Vortex smart cooler amenity in an apartment building common area"
  />
);

export default ApartmentVending;
